import React from 'react';

import { Formik, Form as FormikForm } from 'formik';

import { Button, Modal } from '@shared/components/bootstrap';
import { FormikInputFormGroup } from '@shared/components/fields/formik/formik_input_form_group';

import { type Landing__Location__FactInput } from '@admin/schema';

export const LandingLocationFactModal: React.FC<{
  fact?: Landing__Location__FactInput;
  onClose(): void;
  onSave(input: Landing__Location__FactInput): void;
}> = ({ fact, onClose, onSave }) => {
  const onSubmit = (input: Landing__Location__FactInput) => {
    if (!input.title || !input.description) return;
    onSave(input);
  };

  return (
    <Modal onClose={onClose}>
      <Formik<Landing__Location__FactInput>
        initialValues={{
          title: fact?.title ?? '',
          description: fact?.description ?? '',
        }}
        onSubmit={onSubmit}
      >
        <FormikForm>
          <Modal.Content>
            <Modal.Header>
              <Modal.Title>Fact</Modal.Title>
              <Modal.Close close={onClose} />
            </Modal.Header>
            <Modal.Body>
              <FormikInputFormGroup id="title" name="title" label="Title:" />
              <FormikInputFormGroup id="description" name="description" label="Description:" />
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" kind="primary">
                Save
              </Button>
            </Modal.Footer>
          </Modal.Content>
        </FormikForm>
      </Formik>
    </Modal>
  );
};
